import React from "react";

import { faArrowRight } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { CalendarPageNavState } from "~/calendar/CalendarPage";
import { isMobile, isNative } from "~/lib/utils";
import { LinkButton } from "~/ui";
import { useTourContext } from "~/welcomeChecklist";

import styles from "~/nav/panels/Meetings/MeetingsPanel.global.module.css";

export default function OpenWeekViewButton({ currentDate }: { currentDate: Date }) {
	const { activeTour } = useTourContext();

	if (isNative || isMobile) return null;

	return (
		<LinkButton<CalendarPageNavState>
			to={{
				pathname: "/calendar/",
				state: { currentDate },
			}}
			variant="secondary"
			size="slim"
			className={styles.fullViewButton}
			disabled={activeTour !== null}
		>
			Open my week&ensp;
			<FontAwesomeIcon icon={faArrowRight} />
		</LinkButton>
	);
}
